import React, {useContext} from 'react';
import NodeHandles from './NodeHandles';
import {NodeData} from '../models';
import {LessonContentChallengeBranchTextOption} from '../../../data/models/LessonContent/LessonContentBase';
import {EditorContext} from '../container/LessonEditorContainer';
import Tooltip from '../../../uiToolkit/Tooltip';

interface Props {
  data: NodeData;
}

const ChallengeBranchTextNode = React.memo(({data}: Props) => {
  const context = useContext(EditorContext);

  const onClick = (e: any) => {
    context.setSelectedNode(data.payload, data.type);
    e.stopPropagation();
  };

  return (
    <NodeHandles>
      <div className="EditorNodeContainer">
        <div>
          {(data.payload as LessonContentChallengeBranchTextOption)
            .isCorrect ? (
            <span className="icon-typeCheck ChallengeCorrect"></span>
          ) : (
            <span className="icon-typeClose ChallengeIncorrect"></span>
          )}
        </div>
        <div
          onClick={onClick}
          className={`EditorCard ${
            context.selectedNode?.internalId === data.payload.internalId
              ? 'SelectedEditorCard'
              : ''
          }`}>
          <Tooltip
            tooltipText={
              (data.payload as LessonContentChallengeBranchTextOption).answer
            }
            greenTooltip>
            <p className="ChoiceQuestionNode">
              {(data.payload as LessonContentChallengeBranchTextOption).answer}
            </p>
          </Tooltip>
        </div>
      </div>
    </NodeHandles>
  );
});

export default ChallengeBranchTextNode;
